"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _getScrollInfo = require("get-scroll-info");
var _type = require("./type.js");
//@ts-check

/**
 * @param {DomInfoType} domInfo
 * @param {ScrollInfoType} scrollInfo
 * @returns {IsOnScreenType}
 */
var isOnScreen = function isOnScreen(domInfo, scrollInfo, margin) {
  if (margin === void 0) {
    margin = 0;
  }
  /**
   * @type IsOnScreenType
   */
  var nextDomInfo = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, domInfo), {}, {
    atTop: domInfo.bottom <= scrollInfo.top + margin,
    atRight: domInfo.left >= scrollInfo.right - margin,
    atBottom: domInfo.top >= scrollInfo.bottom - margin,
    atLeft: domInfo.right <= scrollInfo.left + margin,
    isOnScreen: false
  });
  nextDomInfo.isOnScreen = !(nextDomInfo.atTop || nextDomInfo.atRight || nextDomInfo.atBottom || nextDomInfo.atLeft);
  return nextDomInfo;
};
var _default = exports["default"] = isOnScreen;
module.exports = exports.default;